import React, { useState, useEffect } from "react";
import axios from "axios";
import qs from "qs";
import "./Dashboard.css";
import config from "../config";

// Radio -> Backend value
const MACHINE_QUERY = {
  flow: "flowcontrol",
  packing: "packing",
};

function Dashboard() {
  const [deviceName, setDeviceName] = useState("");
  const [deviceId, setDeviceId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [responseMsg, setResponseMsg] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const [debounceTimer, setDebounceTimer] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isSelecting, setIsSelecting] = useState(false);

  const [userKey, setUserKey] = useState(0);
  const [searchResultCount, setSearchResultCount] = useState(0);

  const [registerType, setRegisterType] = useState("flow");

  // deviceType
  const [deviceType, setdeviceType] = useState("flowcontrol");

  // NEW: Silo states
  const [siloEnabled, setSiloEnabled] = useState(false);
  const [activeSiloCount, setActiveSiloCount] = useState("");

  // Load saved data
  useEffect(() => {
    const storedData = sessionStorage.getItem("deviceData");

    if (storedData) {
      try {
        const parsed = JSON.parse(storedData);

        setDeviceName(parsed.deviceName || "");
        setDeviceId(parsed.deviceId || "");
        setCompanyName(parsed.companyName || "");
        setdeviceType(parsed.deviceType || "flowcontrol");

        // Silo restore
        setSiloEnabled(parsed.siloEnabled || false);
        setActiveSiloCount(parsed.activeSiloCount || "");

      } catch {
        console.log("Session parse error");
      }
    }
  }, []);

  // Company search
  useEffect(() => {
    if (isSelecting) return;

    if (debounceTimer) clearTimeout(debounceTimer);

    const timer = setTimeout(() => {
      const q = companyName.trim();

      if (q !== "") {
        axios
          .get(
            `${config.BASE_URL}/admin/search-company-name?companyName=${encodeURIComponent(
              q
            )}`
          )
          .then((res) => {
            const list = Array.isArray(res.data) ? res.data : [];

            setSearchResultCount(list.length);
            setSuggestions(list);
            setShowDropdown(list.length > 0);
          })
          .catch(() => {
            setSuggestions([]);
            setShowDropdown(false);
          });
      } else {
        setSuggestions([]);
        setShowDropdown(false);
      }
    }, 300);

    setDebounceTimer(timer);

    return () => clearTimeout(timer);

  }, [companyName]);

  // REGISTER
  const handleRegister = async (e) => {
    e.preventDefault();

    setResponseMsg("");

    const cleanDeviceId = Number(deviceId);

    if (!cleanDeviceId || isNaN(cleanDeviceId)) {
      setResponseMsg("Invalid device ID");
      return;
    }

    const selecteddeviceType = MACHINE_QUERY[registerType];

    // keep in state
    setdeviceType(selecteddeviceType);

    const endpoint = `${config.BASE_URL}/admin/create-table?deviceId=${cleanDeviceId}&deviceType=${selecteddeviceType}`;

    const body = {
      deviceName,
      companyName,
    };

    console.log("REGISTER DATA:", {
      deviceId: cleanDeviceId,
      deviceType: selecteddeviceType,
      body,
    });

    try {
      const res = await axios.post(endpoint, qs.stringify(body), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const responseData = res.data;

      const fullData = {
        ...responseData,
        deviceId: cleanDeviceId,
        deviceName,
        companyName,
        deviceType: selecteddeviceType,

        // Silo data
        siloEnabled,
        activeSiloCount,
      };

      sessionStorage.setItem("deviceData", JSON.stringify(fullData));

      setResponseMsg(responseData.message || "Registered Successfully");

    } catch (err) {

      const msg =
        err?.response?.data?.message ||
        err?.response?.data ||
        err.message;

      setResponseMsg("Error: " + msg);
    }
  };

  // Select company
  const handleSelect = (name, key) => {

    setUserKey(key);
    setIsSelecting(true);

    setCompanyName(name);

    setSuggestions([]);
    setShowDropdown(false);
  };

  // MAPPING
  const handleMapping = async () => {

    const isNewUser = searchResultCount === 0 || !isSelecting;

    const payload = {
      deviceId: Number(deviceId),
      deviceName,
      companyName,
      userKey,
      newUser: isNewUser,

      // deviceType
      deviceType: deviceType,

      // Silo data
      siloEnabled,
      activeSiloCount: siloEnabled
        ? Number(activeSiloCount)
        : 0,
    };

    console.log("MAPPING DATA:", payload);

    try {
      const res = await axios.post(
        `${config.BASE_URL}/admin/register-device`,
        payload
      );

      const data = res.data;

      if (data.newUser && data.userId && data.password) {
        sessionStorage.setItem("newUserId", data.userId);
        sessionStorage.setItem("newUserPassword", data.password);
        sessionStorage.setItem("isNewUser", "true");
      }

      setPopupData({
        deviceName,
        deviceId,
        companyName,
        userId: data.userId,
        password: data.password,
        isNewUser: data.newUser,
        deviceType: deviceType,

        // silo data
        siloEnabled,
        activeSiloCount,
      });

      // Reset
      setDeviceName("");
      setDeviceId("");
      setCompanyName("");
      setResponseMsg("");

      setSiloEnabled(false);
      setActiveSiloCount("");

      sessionStorage.removeItem("deviceData");

      setShowPopup(true);

    } catch (err) {

      setPopupData({
        error:
          err?.response?.data?.message ||
          err.message,
      });

      setShowPopup(true);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  return (
  <div className="dashboard-form-container">

    <h2>Device Information Form</h2>

    <form onSubmit={handleRegister}>

      {/* Device ID */}
      <div>
        <label>Device ID:</label>

        <input
          type="text"
          value={deviceId}
          onChange={(e) => setDeviceId(e.target.value)}
          required
        />
      </div>

      {/* Machine Type */}
      <div className="machine-type-container">

        {/* Flow */}
        <div className="form-section-margin">
          <label className="machine-radio-label">

            <input
              type="radio"
              name="registerType"
              value="flow"
              checked={registerType === "flow"}
              onChange={() => {
                setRegisterType("flow");
                setdeviceType("flowcontrol");
              }}
            />

            <span>Flow Controller Register</span>

          </label>
        </div>

        {/* Packing */}
        <div className="form-section-margin">
          <label className="machine-radio-label">

            <input
              type="radio"
              name="registerType"
              value="packing"
              checked={registerType === "packing"}
              onChange={() => {
                setRegisterType("packing");
                setdeviceType("packing");

                // reset silo
                setSiloEnabled(false);
                setActiveSiloCount("");
              }}
            />

            <span>Packing Register</span>

          </label>
        </div>

      </div>

      {/* Silo Options */}
      {registerType === "flow" && (
        <div className="silo-section">

          <label className="silo-title">
            Silo Option
          </label>

          <div className="radio-group">

            {/* With Silo */}
            <label className="silo-radio-label">

              <input
                type="radio"
                name="siloOption"
                checked={siloEnabled === true}
                onChange={() => {
                  setSiloEnabled(true);
                  setActiveSiloCount("1");
                }}
              />

              <span>With Silo</span>

            </label>

            {/* Without Silo */}
            <label className="silo-radio-label">

              <input
                type="radio"
                name="siloOption"
                checked={siloEnabled === false}
                onChange={() => {
                  setSiloEnabled(false);
                  setActiveSiloCount("");
                }}
              />

              <span>Without Silo</span>

            </label>

          </div>

          {/* Dropdown */}
          {siloEnabled && (
            <div className="silo-select-wrapper">

              <label>Select Silo Count</label>

              <select
                value={activeSiloCount}
                onChange={(e) =>
                  setActiveSiloCount(e.target.value)
                }
              >
                <option value="1">1-Silo</option>
                <option value="2">2-Silo</option>
                <option value="3">3-Silo</option>
                <option value="4">4-Silo</option>
                <option value="5">5-Silo</option>
                <option value="6">6-Silo</option>
              </select>

            </div>
          )}

        </div>
      )}

      {/* Device Name */}
      <div>
        <label>Device Name:</label>

        <input
          type="text"
          value={deviceName}
          onChange={(e) => setDeviceName(e.target.value)}
          required
        />
      </div>

      {/* Company */}
      <div>
        <label>Company Name:</label>

        <input
          type="text"
          value={companyName}
          onChange={(e) => {
            setCompanyName(e.target.value);
            setIsSelecting(false);
          }}
          required
        />
      </div>

      {/* Suggestions */}
      {showDropdown && suggestions.length > 0 && (
        <ul className="suggestion-dropdown">

          {suggestions.map((item, idx) => (
            <li
              key={idx}
              onClick={() =>
                handleSelect(item.companyName, item.userKey)
              }
            >
              {item.companyName}
            </li>
          ))}

        </ul>
      )}

      {/* Buttons */}
      <div className="button-row1">

        <button type="submit">
          Register
        </button>

        <button
          type="button"
          onClick={handleMapping}
        >
          Mapping
        </button>

      </div>

      {/* Response */}
      {responseMsg && (
        <p className="response-msg">
          {responseMsg}
        </p>
      )}

    </form>

    {/* Popup */}
    {showPopup && popupData && (

      <div className="popup-overlay">

        <div className="popup-content">

          <h3>Mapping Response</h3>

          {popupData.error ? (

            <p style={{ color: "red" }}>
              {popupData.error}
            </p>

          ) : (

            <div>

              <p>
                <strong>Device Name:</strong>{" "}
                {popupData.deviceName}
              </p>

              <p>
                <strong>Device ID:</strong>{" "}
                {popupData.deviceId}
              </p>

              <p>
                <strong>Company Name:</strong>{" "}
                {popupData.companyName}
              </p>

              <p>
                <strong>Machine Type:</strong>{" "}
                {popupData.deviceType}
              </p>

              <p>
                <strong>Silo Enabled:</strong>{" "}
                {popupData.siloEnabled ? "Yes" : "No"}
              </p>

              {popupData.siloEnabled && (
                <p>
                  <strong>Active Silo Count:</strong>{" "}
                  {popupData.activeSiloCount}
                </p>
              )}

              {popupData.isNewUser && (
                <>
                  <p>
                    <strong>User ID:</strong>{" "}
                    {popupData.userId}
                  </p>

                  <p>
                    <strong>Password:</strong>{" "}
                    {popupData.password}
                  </p>
                </>
              )}

            </div>

          )}

          <button onClick={closePopup}>
            X
          </button>

        </div>

      </div>
    )}

  </div>
);
}

export default Dashboard;